import React from "react";
import "./JetCard.css";
import { FiUsers } from "react-icons/fi";
import {Link} from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function JetCard({ jet, reverse = false }) {
   const navigate = useNavigate();

  const goToDetails = () => {
    navigate(`/aircrafts/${jet.id}`, { state: { jet } });
  };
  
const { t } = useTranslation("jetcard");

   const heroSrc = jet.images?.hero ?? jet.image;
  return (
    <article className={`jet-row ${reverse ? "reverse" : ""}`}>
      <div className="jet-media">
        <img src={heroSrc} alt={jet.name} loading="lazy" />
      </div>

      <div className="jet-content">
        <h3 className="jet-title">{jet.name}</h3>
        <p className="jet-meta">
          {jet.manufacturer} • {jet.year} • {jet.category || "Long Range"}
        </p>

        <ul className="jet-specs">
          <li><span>{t("specs.range")}</span><strong>{jet.range}</strong></li>
          <li><span>{t("specs.speed")}</span><strong>{jet.speed}</strong></li>
          <li><strong>{jet.capacity} <FiUsers className="meta-icon" />  </strong></li>
          {jet.hours && <li><span>{t("specs.hours")}</span><strong>{jet.hours}</strong></li>}
        </ul>

        <p className="jet-desc">
          {jet.shortDescription || t("defaultDescription")}
        </p> 

        <div className="jet-cta">
       <button className="btn primary" onClick={goToDetails}>{t("cta.details")}</button>
         
        </div>
      </div>
    </article>
  );
}
